import { render } from "./PhotographerVTwo.vue?vue&type=template&id=a88e5072&scoped=true"
import script from "./PhotographerVTwo.vue?vue&type=script&lang=js"
export * from "./PhotographerVTwo.vue?vue&type=script&lang=js"

import "./PhotographerVTwo.vue?vue&type=style&index=0&id=a88e5072&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a88e5072"]])

export default __exports__